import { useCallback, useSyncExternalStore } from 'react';

// Estado compartido de "ocultar nombres" para todas las vistas de participantes y del torneo.
// Se guarda en localStorage: si se oculta en una vista y se entra a otra, ya aparece oculto.
// Por defecto los nombres están ocultos (lo más seguro para una pantalla pública).
export const HIDE_NAMES_KEY = 'hide-participant-names';

// Respaldo en memoria: solo se usa si el almacenamiento está bloqueado (modo privado, políticas del navegador).
let storageBroken = false;
let memoryValue = true;
const listeners = new Set();

const read = () => {
  if (storageBroken) return memoryValue;
  try {
    const stored = window.localStorage.getItem(HIDE_NAMES_KEY);
    return stored === null ? true : stored === 'true';
  } catch {
    return memoryValue;
  }
};

const write = (hidden) => {
  memoryValue = hidden;
  try {
    window.localStorage.setItem(HIDE_NAMES_KEY, String(hidden));
    storageBroken = false;
  } catch {
    storageBroken = true; // sin almacenamiento: el valor se mantiene mientras la pantalla esté abierta
  }
  listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
  listeners.add(listener);
  const onStorage = (event) => {
    if (event.key === null || event.key === HIDE_NAMES_KEY) listener(); // cambio hecho en otra pestaña
  };
  window.addEventListener('storage', onStorage);
  return () => {
    listeners.delete(listener);
    window.removeEventListener('storage', onStorage);
  };
};

export default function useHideNames() {
  const hidden = useSyncExternalStore(subscribe, read);
  const toggle = useCallback(() => write(!read()), []);
  return [hidden, toggle];
}
